<script setup lang="ts">
definePageMeta({
  layout: 'blank',
});

const { modalType } = storeToRefs(useLayoutStore());
const { closeModal } = useLayoutStore();
const router = useRouter();

const closeModalOrGoToHome = () => {
  if (window.opener && window.opener !== window) {
    window.close();
  } else {
    router.back();

    return;
  }

  if (window.self !== window.top) {
    closeModal();
    window.parent.postMessage('closeModal');
  }
};

onMounted(() => {
  modalType.value = 'help';
  window.parent.postMessage('iframeReady');
});
</script>

<template>
  <AuthPageLayout
    large-content
    @action-to-close="closeModalOrGoToHome"
  >
    <PagesHelp />
  </AuthPageLayout>
</template>
